import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl} from '@angular/platform-browser';

export enum SafeType {
  html = 'html',
  resourceUrl = 'resourceUrl',
  style = 'style',
  url = 'url',
}

@Pipe({name: 'safe'})
export class SafePipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {
  }

  public transform(value: any, type: SafeType | string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case SafeType.html:
        return this.sanitizer.bypassSecurityTrustHtml(value);
      case SafeType.resourceUrl:
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      case SafeType.style:
        return this.sanitizer.bypassSecurityTrustStyle(value);
      case SafeType.url:
        return this.sanitizer.bypassSecurityTrustUrl(value);
      default:
        return value;
    }
  }
}
